export const fieldSortFunc = function(fieldArray:any,sortField:string){
    /******************循环查找是否按照指定字段进行输出 start**************************** */
    let sortN:number = 0;
    let maxOrder:number = 0;
    let isSort:boolean = false;
    for(let fieldI=0; fieldI<fieldArray.length; fieldI++){
        let fieldData:any = fieldArray[fieldI];
        if(typeof(fieldData[sortField])=='number'){
            if(fieldData[sortField] > maxOrder){
                maxOrder = fieldData[sortField];//找到最大的排序值
            }
            sortN++;
        }
    }
    if(sortN == fieldArray.length){
        isSort = true;//全部都配置了排序字段
    }else{
        if(sortN > 0){
            isSort = true;//没有都配置排序字段 找到没有设置的，给默认值（最大值累加）
            for(let fieldI=0; fieldI<fieldArray.length; fieldI++){
                let fieldData:any = fieldArray[fieldI];
                if(typeof(fieldData[sortField])=='undefined'){
                    maxOrder++; 
                    fieldData[sortField] = maxOrder;
                }
            }
        }
    }
    if(isSort === true){
        fieldArray.sort(function(obj1:any,obj2:any){return obj1[sortField] - obj2[sortField]});//排序
    }
    /******************循环查找是否按照指定字段进行输出 start**************************** */
}